<template>
    <div class="qiye">
        <div class="toptitle">企业画像</div>
        <div class="btmcont">
            <div class="topflex line">
                <!-- 左边 -->
                <div style="width: 50%;">
                    <div class="randombox" v-if="type.aviation">
                        <div class="hangkong radius">
                            <div class="hinner radiubox"
                                :style="{ width: type.aviation.size + 'px', height: type.aviation.size + 'px' }">
                                <div class="rlabel">航空</div>
                                <div>{{ type.aviation.value }}</div>
                            </div>
                        </div>
                        <div class="jinrong radius">
                            <div class="jinner radiubox"
                                :style="{ width: type.finance.size + 'px', height: type.finance.size + 'px' }">
                                <div class="rlabel">金融</div>
                                <div>{{ type.finance.value }}</div>
                            </div>
                        </div>
                        <div class="zhizao radius">
                            <div class="zinner radiubox"
                                :style="{ width: type.manufacture.size + 'px', height: type.manufacture.size + 'px' }">
                                <div class="rlabel">制造</div>
                                <div>{{ type.manufacture.value }}</div>
                            </div>
                        </div>
                        <div class="hulian radius">
                            <div class="hinner radiubox"
                                :style="{ width: type.interconnection.size + 'px', height: type.interconnection.size + 'px' }">
                                <div class="rlabel">互联</div>
                                <div>{{ type.interconnection.value }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 右边 -->
                <div class="rightbox line">
                    <div class="qyech" ref="qyech"></div>
                    <div class="qyech" ref="rkech"></div>
                </div>
            </div>
            <div class="bcont">
                <div ref="shangshiech" class="shangshi"></div>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';

export default {
    data() {
        return {
            type: {},
            qyech: null,
            rkech: null,
            shangshiech: null
        }
    },
    mounted() {
        this.getQiyeData()

        // 监听窗口 resize，图表自适应
        window.addEventListener('resize', () => {
            this.qyech.resize();
            this.rkech.resize();
            this.shangshiech.resize();
        });
    },
    methods: {
        getQiyeData() {
            this.$api({
                url: '/api/central_control/enterprise_profile',
                method: 'POST',

            }).then(res => {
                // 行业类型
                // 1. 提取数值型键值对并排序（从大到小）
                const sortedEntries = Object.entries(res.data.industry_type)
                    .filter(([_, value]) => typeof value === 'number' && !isNaN(value) && isFinite(value))
                    .sort(([, v1], [, v2]) => v2 - v1); // 按value从大到小排序

                // 2. 给每一项添加size（从大到小分配，例如按索引反向生成，或自定义数值范围）
                const result = sortedEntries.map(([key, value], index) => {
                    // 自定义size范围（如最大100，最小50，按比例分配）
                    const total = sortedEntries.length;
                    const maxSize = 80;
                    const minSize = 50;
                    // 按比例计算size（最大项为maxSize，最小项为minSize）
                    const size = Math.round(maxSize - (index * (maxSize - minSize) / (total - 1 || 1))); // 避免除以0
                    return [key, { value, size }];
                });
                // 4. 转换回对象
                const sortedObj = Object.fromEntries(result);
                this.type = sortedObj
                // 企业类型
                this.initQiyeEcharts(res.data.enterprise_type);
                // 人口规模
                let renkouData = Object.values(res.data.population_size)
                this.initRkech(renkouData);
                // 上市
                this.initShangshiEcharts(res.data.listed_company);

            })
        },
        // 上市
        initShangshiEcharts(data) {
            this.shangshiech = echarts.init(this.$refs.shangshiech);
            let option = {
                grid: {
                    top: '30%',
                    left: '5%',
                    right: '5%',
                    bottom: '10%'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['非上市企业', '上市企业'], // 图例数据，与 series 中 name 对应
                    top: 10,
                    right: '5%',
                    show: true,
                    textStyle: {
                        color: '#fff'
                    },
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.1],
                    show: false
                },
                yAxis: {
                    type: 'category',
                    data: [''], // y 轴只有一个类目（因为是横向单组对比）
                    axisTick: { show: false },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: '#fff'
                        }
                    }
                },
                series: [
                    {
                        name: '非上市企业', // 系列名称
                        type: 'bar',
                        data: [data.no_listed_company],
                        // 核心：添加label配置，在柱子上方显示数据
                        label: {
                            show: true, // 显示标签
                            position: 'right', // 标签位置：顶部
                            textStyle: {
                                color: '#fff', // 标签颜色（根据背景调整）
                                fontSize: 12 // 标签字体大小
                            }
                        },
                        barMinWidth: 24,
                        itemStyle: {
                            borderRadius: 50,
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 1, 1,// 圆心 x、y（0.5 为中心），半径 0.5
                                [
                                    { offset: 0, color: '#FFDE53' },
                                    { offset: 1, color: '#E7C01A' }
                                ]
                            )
                        }
                    },
                    {
                        name: '上市企业', // 系列名称
                        type: 'bar',
                        data: [data.listed_company],
                        // 核心：添加label配置，在柱子上方显示数据
                        label: {
                            show: true, // 显示标签
                            position: 'right', // 标签位置：顶部
                            textStyle: {
                                color: '#fff', // 标签颜色（根据背景调整）
                                fontSize: 12 // 标签字体大小
                            }
                        },
                        barMinWidth: 24,


                        itemStyle: {
                            borderRadius: 50,
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 1, 1,// 圆心 x、y（0.5 为中心），半径 0.5
                                [
                                    { offset: 0, color: '#50B4AF' },
                                    { offset: 1, color: '#32DDD1' }
                                ]
                            )
                        }
                    }
                ]
            };
            this.shangshiech.setOption(option);
        },
        initRkech(data) {
            this.rkech = echarts.init(this.$refs.rkech);
            let option = {
                // 设置图表标题
                title: {
                    text: '人口规模',
                    left: 'center',
                    top: 'bottom',
                    textStyle: {
                        color: '#fff',
                        fontSize: 14
                    }
                },
                // 设置tooltip，鼠标悬浮时显示提示信息
                tooltip: {},
                // 设置图例
                legend: {
                    data: ['人口规模']
                },
                // 设置x轴
                xAxis: {
                    data: ['≤1000', '>1000']
                },
                // 设置y轴
                yAxis: {
                    show: false

                },
                // 设置系列数据（柱状图数据）
                series: [
                    {
                        // name: '数量',
                        type: 'bar', // 图表类型为柱状图
                        data, // 对应“国有”和“民营”的数值
                        barWidth: 18,
                        // 核心：添加label配置，在柱子上方显示数据
                        label: {
                            show: true, // 显示标签
                            position: 'top', // 标签位置：顶部
                            textStyle: {
                                color: '#fff', // 标签颜色（根据背景调整）
                                fontSize: 12 // 标签字体大小
                            }
                        },
                        itemStyle: {
                            borderRadius: 50,
                            color: function (params) {
                                // 自定义柱子颜色，
                                const colorList = ['#586DE4', '#E277D2'];
                                return colorList[params.dataIndex];
                            },

                        }
                    }
                ]
            }
            this.rkech.setOption(option);
        },
        initQiyeEcharts(data) {
            this.qyech = echarts.init(this.$refs.qyech);
            let option = {
                // 设置图表标题
                title: {
                    text: '企业类型',
                    left: 'center',
                    top: 'bottom',
                    textStyle: {
                        color: '#fff',
                        fontSize: 14
                    }
                },
                // 设置tooltip，鼠标悬浮时显示提示信息
                tooltip: {},
                // 设置图例
                legend: {
                    data: ['企业类型']
                },
                // 设置x轴
                xAxis: {
                    data: ['国有', '民营']
                },
                // 设置y轴
                yAxis: {
                    show: false
                },
                // 设置系列数据（柱状图数据）
                series: [
                    {
                        // name: '数量',
                        type: 'bar', // 图表类型为柱状图
                        data: [data.country, data.private], // 对应“国有”和“民营”的数值
                        barWidth: 18,
                        // 核心：添加label配置，在柱子上方显示数据
                        label: {
                            show: true, // 显示标签
                            position: 'top', // 标签位置：顶部
                            textStyle: {
                                color: '#fff', // 标签颜色（根据背景调整）
                                fontSize: 12 // 标签字体大小
                            }
                        },
                        itemStyle: {
                            borderRadius: 50,
                            color: function (params) {
                                // 自定义柱子颜色，这里“国有”用浅蓝色，“民营”用浅绿色
                                const colorList = ['#4ADDE7', '#6CE3B8'];
                                return colorList[params.dataIndex];
                            },
                        }
                    }
                ]
            }
            this.qyech.setOption(option);
        }
    }
}
</script>
<style scoped lang="less">
.bcont {
    width: 100%;
    height: 35%;

    .shangshi {
        width: 100%;
        height: 100%;
        // position: relative;
        // top: -30%;
        // padding-top: 30%;

    }
}


.qyech {
    width: 30%;
    height: 100%;
}

.rightbox {
    display: flex;
    align-items: center;
    width: 50%;
    justify-content: space-around;
    border-left: 2px solid;
    height: 100%;
}

.topflex {
    display: flex;
    height: 65%;
    border-bottom: 2px solid;
    width: 100%;
    padding-bottom: 10px;

    .randombox {
        position: relative;

        .hulian {
            background: rgba(149, 23, 246, 0.25);

            top: 110px;
            left: 240px;

            .hinner {
                background: #9517F6;
            }
        }

        .zhizao {
            background: rgba(82, 130, 253, 0.25);
            left: 58px;
            top: 110px;

            .zinner {
                background: #5282FD;
            }
        }

        .jinrong {
            background: rgba(235, 119, 94, 0.25);
            left: 170px;
            top: 10px;

            .jinner {
                background: #EB775E;
            }
        }

        .hangkong {
            background: rgba(210, 60, 146, 0.25);
            left: 50px;
            top: 17px;

            .hinner {
                background: #D23C92;
            }
        }
    }

    .radius {
        border-radius: 50%;
        padding: 10px;
        position: absolute;
    }

    .radiubox {
        text-align: center;
        color: #fff;
        font-size: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 50%;

        .rlabel {
            margin-bottom: 5px;
        }
    }

}

.btmcont {
    background: url('@/assets/conbgBig.png') no-repeat 0 0/100% 100%;
    width: 100%;
    height: calc(((100vh - 100px) / 2) - 50px);
    padding: 10px 26px;
    color: #fff;
    // display: flex;
    // justify-content: center;
}
</style>